module.exports = __webpack_public_path__ + "media/images/event/event-template-ru-c0a6f0c4b034941f9cefa0d7ea4398bc.png";